import { useEffect, useState } from 'react';
import { Library, Copy, ChevronDown, ChevronUp, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import API from '../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';

const CAT = { calificare: 'Calificare', tehnic: 'Tehnic', financiar: 'Financiar', experienta: 'Experienta', resurse: 'Resurse Umane', general: 'General' };

export default function SuggestedResponses({ projectId }) {
  const [items, setItems] = useState(null);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    if (!projectId) return;
    API.get(`/responses/suggest/${projectId}`).then(r => setItems(r.data.suggestions || [])).catch(() => setItems([]));
  }, [projectId]);

  const copy = async (it) => {
    navigator.clipboard.writeText(it.content);
    API.post(`/responses/${it.id}/use`).catch(() => {});
    toast.success('Răspuns copiat din Bibliotecă');
  };

  if (items === null) return <Card className="bg-card border-white/10"><CardContent className="p-6 flex items-center gap-2 text-sm text-muted-foreground"><Loader2 className="w-4 h-4 animate-spin" />Se caută răspunsuri relevante…</CardContent></Card>;
  if (!items.length) return null;

  return (
    <Card className="bg-card border-white/10" data-testid="suggested-responses">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2" style={{ fontFamily: 'Outfit' }}>
          <Library className="w-4 h-4 text-indigo-400" />Răspunsuri sugerate din Bibliotecă
        </CardTitle>
        <p className="text-xs text-muted-foreground mt-1">Răspunsuri reutilizabile la solicitări de clarificare, potrivite automat pentru acest proiect. Copiază-le direct în ofertă.</p>
      </CardHeader>
      <CardContent className="space-y-2">
        {items.map(it => (
          <div key={it.id} className="rounded-lg border border-white/5 bg-zinc-900/40" data-testid={`suggest-${it.id}`}>
            <div className="flex items-center gap-2 p-3">
              <Badge variant="outline" className="text-[10px] bg-indigo-500/10 text-indigo-300 ring-indigo-500/20 ring-1 ring-inset border-0 shrink-0">{CAT[it.category] || it.category}</Badge>
              <span className="text-sm font-medium truncate flex-1">{it.title}</span>
              {it.match > 0 && <span className="text-[10px] text-emerald-400 shrink-0">{it.match} potriviri</span>}
              <Button size="sm" variant="ghost" className="h-7 text-xs shrink-0" onClick={() => copy(it)} data-testid={`suggest-copy-${it.id}`}><Copy className="w-3 h-3 mr-1" />Copiază</Button>
              <button className="p-1 text-muted-foreground hover:text-foreground shrink-0" onClick={() => setOpenId(openId === it.id ? null : it.id)} data-testid={`suggest-toggle-${it.id}`}>{openId === it.id ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}</button>
            </div>
            {openId === it.id && <div className="px-3 pb-3 text-xs text-muted-foreground whitespace-pre-wrap border-t border-white/5 pt-2">{it.content}</div>}
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
